import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useModal } from "@/modals"
import {
  INFO_MODAL_TYPES,
  useGetInfoModalHasReadQuery,
  useMarkInfoModalAsReadMutation
} from "@/store/apis/infoModalAPI"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import { TermsOfUseContent } from "@/ui/TermsOfUseContent"
import styles from "./TermsOfUseModal.module.scss"

const modalType = "termsOfUse"
const LEGAL_LANG = "en"

export const TermsOfUseModal: FC = () => {
  const { modal } = useModal(modalType)
  const { t } = useTranslation()

  const { data, isLoading: isHasReadLoading } = useGetInfoModalHasReadQuery({
    type: INFO_MODAL_TYPES.TERMS,
    lang: LEGAL_LANG
  })
  const [markAsRead, { isLoading: isMarkLoading }] =
    useMarkInfoModalAsReadMutation()

  const isGateMode = data?.hasRead !== true

  const handleAgree = async () => {
    await markAsRead({
      type: INFO_MODAL_TYPES.TERMS,
      lang: LEGAL_LANG
    }).unwrap()
    modal.close()
  }

  const handleClose = () => modal.close()

  return (
    <Modal.Fullscreen
      type={modalType}
      isCanClose={!isGateMode}
      className={clsx(styles.TermsOfUseModal)}
    >
      <div className={clsx(styles.TermsOfUseModal_content)}>
        <TermsOfUseContent />
      </div>
      <div className={clsx(styles.TermsOfUseModal_footer)}>
        <Button
          styles="yellow"
          disabled={isHasReadLoading || isMarkLoading}
          onClick={isGateMode ? handleAgree : handleClose}
        >
          {isGateMode ? t("legal.agree") : t("button.close")}
        </Button>
      </div>
    </Modal.Fullscreen>
  )
}
